module.exports = __webpack_public_path__ + "static/media/ic-landing-role.6bbbf6cf.png";